import { DateTime } from 'luxon'
import { SUBSCRIPTION_PRICE } from '../constants'

// Subscribing ends the trial and charges the first month right away, so trial copy never says "after trial"
export const SUBSCRIBE_CHARGE_TEXT = `${SUBSCRIPTION_PRICE}, charged when you subscribe`

export const daysLeftText = (days: number) => (days === 1 ? '1 day left' : `${days} days left`)

// trial_ends_at is server-computed RFC3339 UTC; show it as a local date, with the year only when it differs.
export const formatTrialEndDate = (trialEndsAt?: string | null, now: DateTime = DateTime.local()) => {
    if (!trialEndsAt) return null
    const endsAt = DateTime.fromISO(trialEndsAt, { zone: 'utc' }).setZone(now.zone)
    if (!endsAt.isValid) return null
    return endsAt.toFormat(endsAt.year === now.year ? 'LLL d' : 'LLL d, yyyy')
}

const MANAGEABLE_SUBSCRIPTION_STATUSES = new Set(['active', 'trialing', 'past_due', 'unpaid', 'paused', 'incomplete'])

export const hasManageableSubscriptionStatus = (subscriptionStatus?: string, isSubscribed?: boolean) =>
    Boolean(isSubscribed || (subscriptionStatus && MANAGEABLE_SUBSCRIPTION_STATUSES.has(subscriptionStatus)))
